import { CalendarGrid } from '../../../CalendarGrid'

import { ViewingCalendarItemTag } from './ViewingCalendarItemTag'

function RentalPortalViewingCalendar({
  calendar,
  onClickApplicant,
  onClickEmptyCell,
  onClickViewing,
}) {
  function handleClickItem(item, event) {
    onClickViewing(item.source, event)
  }

  function handleClickSecondaryLabel(item) {
    onClickApplicant(item.source)
  }

  return (
    <CalendarGrid
      ItemTag={ViewingCalendarItemTag}
      calendar={calendar}
      onClickEmptyCell={onClickEmptyCell}
      onClickItem={handleClickItem}
      onClickSecondaryLabel={handleClickSecondaryLabel}
    />
  )
}

export default RentalPortalViewingCalendar
